import script from "./ProductPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPopup.vue?vue&type=script&setup=true&lang=js"

import "./ProductPopup.vue?vue&type=style&index=0&id=98676d50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98676d50"]])

export default __exports__